import gql from 'graphql-tag';

export const pollContentFragment = gql`
  fragment pollContentFragment on PollContent {
    question
    totalVotes
    expiry

    answers {
      answer
      votes
    }
  }
`;
